module.exports = __webpack_public_path__ + "static/media/restaurant-3.5fe5a13b.jpg";